export default "__VITE_ASSET__BRwWWEvM__"